module.exports = __webpack_public_path__ + "img/Paymen-Completed-dashboard-th.fcfb68e.png";